export enum TaskDurationType {
    Hour = 1,
    Day = 2,
}
